import request from "@utils/request";

// 分类列表
export function getCardCategoryList(data) {
  return request.post("/review/cardCategory/list", data, { login: true });
}

// 订单创建
export function create(data) {
  return request.post("/review/order/create", data, { login: true });
}
// 订单列表
export function getOrderList(data) {
  return request.post("/review/order/list", data, { login: true });
}

// 订单支付
export function pay(data) {
  return request.post("/review/order/pay", data, { login: true });
}

// 测评详情
export function getPaperInfo(data) {
  return request.get("/review/paper/info", data, { login: true });
}
// 试卷列表
export function getPaperList(data) {
  return request.post("/review/paper/list", data, { login: true });
}

// 测评配置
export function getReviewConfig(data) {
  return request.post("/review/review/config", data, { login: true });
}

export function saveRecord(data) {
  return request.post("/review/paper/saveRecord", data, { login: true });
}

// 获取测评结果
export function getReviewResult(params) {
  return request.post(
    "/review/paper/getReviewResult",
    {},
    { params, login: true }
  );
}
// 获取教练详情
export function getProductDetail(id, data) {
  return request.get("/product/detail/" + id, data, { login: true });
}

// 获取随机教练/product/random
export function getProductRandomId() {
  return request.get("/product/random", {}, { login: false });
}

// 测评评价
export function orderReply(data) {
  return request.post("/review/order/reply", data, { login: false });
}

// 检查试卷是否做过
export function paperCheck(data) {
  return request.post("/review/paper/check", data, {
    login: true,
    params: data,
  });
}
